export default function CookiesPolicy() {
  return (
    <div className="min-h-screen bg-white">
      <div className="border-b border-gray-100 bg-gray-50 px-4 py-16 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl">
          <p className="mb-3 text-xs font-bold uppercase tracking-[0.18em] text-orange-500">Legal</p>
          <h1 className="text-3xl font-extrabold tracking-tight text-black sm:text-4xl">Cookies Policy</h1>
          <p className="mt-3 text-sm text-gray-500">Last updated: April 2026</p>
        </div>
      </div>

      <div className="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="space-y-10 text-[15px] leading-relaxed text-gray-600">

          <section>
            <h2 className="mb-3 text-lg font-bold text-black">1. What Are Cookies?</h2>
            <p>Cookies are small text files that are placed on your device when you visit a website. They are widely used to make websites work, function more efficiently, and to provide information to the website owner. Cookies do not contain personally identifiable information on their own.</p>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-bold text-black">2. How We Use Cookies</h2>
            <p>The Focus Traffic Plans website (focustrafficplans.com.au) uses cookies to:</p>
            <ul className="mt-3 list-disc space-y-2 pl-6">
              <li>Ensure the website functions correctly and pages load properly</li>
              <li>Remember your preferences during your visit</li>
              <li>Understand how visitors interact with our website (analytics)</li>
              <li>Improve the performance and usability of the site</li>
            </ul>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-bold text-black">3. Types of Cookies We Use</h2>

            <div className="mt-4 space-y-5">
              <div className="rounded-xl border border-gray-200 p-5">
                <h3 className="mb-1 font-semibold text-black">Essential Cookies</h3>
                <p className="text-sm">These cookies are necessary for the website to function and cannot be switched off. They are usually only set in response to actions you take such as requesting a page or filling in a form.</p>
              </div>
              <div className="rounded-xl border border-gray-200 p-5">
                <h3 className="mb-1 font-semibold text-black">Analytics Cookies</h3>
                <p className="text-sm">These cookies help us understand how visitors use our website by collecting anonymised information such as which pages are visited most often. This helps us improve the site over time.</p>
              </div>
              <div className="rounded-xl border border-gray-200 p-5">
                <h3 className="mb-1 font-semibold text-black">Preference Cookies</h3>
                <p className="text-sm">These cookies allow the website to remember choices you have made (such as your preferred region or language) to provide a more personalised experience.</p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-bold text-black">4. Third-Party Cookies</h2>
            <p>Some cookies on our site may be set by third-party services we use, such as analytics providers. These third parties may have their own privacy policies regarding how they use such information. We recommend reviewing their privacy policies for more information.</p>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-bold text-black">5. Managing Cookies</h2>
            <p>You can control and manage cookies through your browser settings. Most browsers allow you to refuse or delete cookies. Please note that disabling cookies may affect the functionality of our website. Instructions for managing cookies in common browsers:</p>
            <ul className="mt-3 list-disc space-y-1.5 pl-6">
              <li><strong>Chrome:</strong> Settings &rarr; Privacy and Security &rarr; Cookies and other site data</li>
              <li><strong>Safari:</strong> Preferences &rarr; Privacy &rarr; Manage Website Data</li>
              <li><strong>Firefox:</strong> Options &rarr; Privacy &amp; Security &rarr; Cookies and Site Data</li>
              <li><strong>Edge:</strong> Settings &rarr; Cookies and Site Permissions</li>
            </ul>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-bold text-black">6. Changes to This Policy</h2>
            <p>We may update this Cookies Policy from time to time to reflect changes in technology or legislation. The latest version will always be available on our website.</p>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-bold text-black">7. Contact Us</h2>
            <p>If you have any questions about our use of cookies, please contact us at <a href="mailto:info@focustrafficplans.com.au" className="text-orange-500 underline">info@focustrafficplans.com.au</a> or call <a href="tel:1300118170" className="text-orange-500 underline">1300 118 170</a>.</p>
          </section>

        </div>
      </div>
    </div>
  );
}
